import { css } from '@emotion/react'
import Colors from '../../utils/colors'

const Styles = ({ colors }) => {
  const { primary } = Colors()
  const { scales: { grayShades } } = colors
  return ({
    container: css`
      padding: 3.75rem 0;
      background-color: ${primary};
      @media (max-width: 768px) {
        flex-direction: column;
        margin-bottom: 1.25rem;
        padding: 2.5rem 1rem 3rem 1rem;
      }
    `,
    subContainer: css`
      max-width: 68rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      @media (max-width: 768px) {
        margin: 0;
        flex-direction: column;
      }
    `,
    title: css`
      padding-bottom: 1.5rem;
      color: ${grayShades[0]} !important;
      @media (max-width: 768px){
        text-align: center !important;
      }
    `,
    card: css`
      height: 100% !important;
      background: ${grayShades[0]};
      width: 32.875rem !important;
      @media (max-width: 768px) {
        padding: 1.5rem !important;
        max-width: 100% !important;
      }
    `
  })
}

export { Styles }
